import React from "react";

interface CheckboxProps {
  label: string;
  isChecked: boolean;
  onChange: (isChecked: boolean) => void;
}

const Checkbox = ({ label, isChecked, onChange }: CheckboxProps) => {
  const toggleCheckbox = () => {
    onChange(!isChecked);
  };

  return (
    <label className="flex items-center justify-between my-2 cursor-pointer border border-[#C4C4C4] p-2 rounded-md">
      <span className="mr-2 text-primary font-semibold text-xs">{label}</span>
      <div className={`w-6 h-6 border border-gray-400 rounded-md flex items-center justify-center transition-colors ${isChecked ? "bg-green-500" : "bg-white"}`} onClick={toggleCheckbox}>
        {isChecked ? <img src="/logo/tick_white.svg" alt="tick" /> : <img src="/logo/tick_grey.svg" alt="tick" />}
      </div>
    </label>
  );
};

interface CheckboxGroupProps {
  options: { label: string; value: string }[];
  handleCheckboxChange: any;
  selectedValues: string[];
  setSelectedValues: any;
}
export const CheckboxGroup = ({ options, handleCheckboxChange, selectedValues, setSelectedValues }: CheckboxGroupProps) => {
  return (
    <div>
      {options.map((option) => (
        <Checkbox key={option.value} label={option.label} isChecked={selectedValues.includes(option.value)} onChange={(isChecked) => handleCheckboxChange(option.value, isChecked)} />
      ))}
    </div>
  );
};
